import { SocialsProps } from '@/types/shared'
import React from 'react'

const LocationIcons: React.FC<SocialsProps> = ({ size, ...props }) => {
    return (
        <div {...props}>
            <svg
                width={size || 48}
                height={size || 48}
                viewBox="0 0 48 48"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 24C0 37.2548 10.7452 48 24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24ZM24.0276 38.4C24.0276 38.4 17.5849 28.7646 15.3043 23.4077C14.7242 22.1591 14.4 20.7651 14.4 19.2947C14.4 13.9405 18.6981 9.6 24 9.6C29.3019 9.6 33.6 13.9405 33.6 19.2947C33.6 20.4729 33.3919 21.602 33.0107 22.6466H33.0209C31.4927 26.7108 24.0276 38.4 24.0276 38.4Z"
                    fill="black"
                />
                <path
                    d="M24 24.8C27.0928 24.8 29.6 22.2928 29.6 19.2C29.6 16.1072 27.0928 13.6 24 13.6C20.9072 13.6 18.4 16.1072 18.4 19.2C18.4 22.2928 20.9072 24.8 24 24.8Z"
                    fill="black"
                />
            </svg>
        </div>
    )
}

export default LocationIcons
